import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import settings from 'bundle-text:../../settings.module.sass';

export default class Jumpmarks {
  headerHeight: number = parseInt(settings['header-height']);
  scrollOffset: number = 40;
  ViewportWatcher: any;

  constructor(viewportwatcher) {
    this.stickyBox = document.querySelector('[data-hook=sticky-box]');
    if (!this.stickyBox) return;

    gsap.registerPlugin(ScrollTrigger);
    this.ViewportWatcher = viewportwatcher;

    this.stickyContainer = document.querySelector('[data-hook=sticky-container]')
    this.jumpmarks = document.querySelectorAll('.jumpmarks__item > a')
    this.stories = document.querySelectorAll('.story')
    this.topOffset = this.headerHeight + this.scrollOffset;
    this.topOffsetEnd = this.headerHeight + this.scrollOffset + this.stickyBox.offsetHeight;

    this.initStickyBox();
    this.initSections();
    this.initJumpmarks();
    this.initStories();
    this.initResizeWatcher();
  }

  initStickyBox() {
    ScrollTrigger.create({
      trigger: this.stickyContainer,
      start: `top top+=${this.topOffset}px`,
      end: `bottom top+=${this.topOffsetEnd}px`,
      pin: this.stickyBox,
      pinSpacing: false,
      onEnter: () => {
        this.stickyBox.classList.remove('box--faded')
      },
      onLeaveBack: () => {
        this.stickyBox.classList.add('box--faded')
      }
    });
  }

  initJumpmarks() {
    this.jumpmarks.forEach(item => {
      let section = document.querySelector(item.getAttribute('href'))
      let targetID = item.getAttribute('href').split('#')[1]
      let storyMenu = document.querySelector(`.story-preview[data-target-id=${targetID}]`)

      if (storyMenu) {
        storyMenu.classList.add('story-preview--initialized');
        item.addEventListener('mouseover', (e) => storyMenu.classList.add('story-preview--active'));
        item.addEventListener('mouseout', (e) => storyMenu.classList.remove('story-preview--active'));
      }

      item.addEventListener('click', (e) => {
        this.scrollToPosition(section, this.topOffset);
        e.preventDefault();
      })
    })
  }

  initSections() {
    let sections = document.querySelectorAll('[data-hook=jumpmark-section]');
    this.sectionTimelines = []

    sections.forEach(section => {
      let sectionJumpmark = this.stickyBox.querySelector(`[href='#${section.id}']`);
      let jumpmarksItem;
      if (sectionJumpmark) { jumpmarksItem = sectionJumpmark.parentNode };

      this.sectionTimelines[section.id] = ScrollTrigger.create({
        trigger: section,
        start: 'top 25%',
        end: 'bottom 25%',
        onEnter: () => {
          if (jumpmarksItem) {
            this.deactivateJumpmarkItems()
            jumpmarksItem.classList.add('jumpmarks__item--active')
          }
        },
        onEnterBack: () => {
          if (jumpmarksItem) {
            this.deactivateJumpmarkItems()
            jumpmarksItem.classList.add('jumpmarks__item--active')
          }
        },
      })
    })
  }

  initStories() {
    this.storyTimelines = []
    this.stories.forEach((story, index) => {
      let topOffset = this.stickyBox.offsetHeight + this.headerHeight + this.scrollOffset;
      this.storyTimelines[index] = ScrollTrigger.create({
        trigger: story,
        start: `top ${topOffset}px`,
        end: `bottom ${this.scrollOffset + this.headerHeight}px`,
        onEnter: () => this.stickyBox.classList.add('box--faded'),
        onLeave: () => this.stickyBox.classList.remove('box--faded'),
        onEnterBack: () => this.stickyBox.classList.add('box--faded'),
        onLeaveBack: () => this.stickyBox.classList.remove('box--faded'),
      })
    })
  }

  deactivateJumpmarkItems() {
    let allActiveJumpmarks = document.querySelectorAll('.jumpmarks__item--active');
    allActiveJumpmarks.forEach(jumpmark => jumpmark.classList.remove('jumpmarks__item--active'));
  }

  scrollToPosition(targetElement, offset=0) {
    let targetViewportOffset = targetElement.getBoundingClientRect().top;
    let windowScrollY = window.pageYOffset;
    let scrollPos = windowScrollY + targetViewportOffset - offset;
    window.scrollTo({
      top: scrollPos,
      behavior: 'smooth'
    });
  }

  initResizeWatcher() {
    window.addEventListener('viewport:resized', () => ScrollTrigger.refresh());
  }
}
